"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'AccessGroupForm',
  bodyClass: 'pages-new-update-form-page',
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput
  },
  data: function data() {
    return {
      idPage: this.$route.params.id,
      // Listar páginas
      listLinksPagesToGroup: [],
      form: {
        name: '',
        active: false,
        isAdmin: false,
        canViewSensitiveData: false,
        codGroup: ''
      }
    };
  },
  computed: {
    title: function title() {
      if (this.$route.params.id) {
        return 'Alterar Grupo de Acesso';
      }
      return 'Cadastrar Grupo de Acesso';
    }
  },
  validations: function validations() {
    return {
      form: {
        name: {
          required: _validators.required
        },
        codGroup: {
          required: _validators.required
        },
        active: {},
        isAdmin: {},
        canViewSensitiveData: {}
      }
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      this.getDetailDetailAccessGroup();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['createAccessGroup', 'updateAccessGroup', 'fetchAccessGroup', 'fetchPagesLinkGroup', 'addPageToAccessGroup', 'removePageToAccessGroup'])), {}, {
    cancel: function cancel(e) {
      e.preventDefault();
      this.$v.$reset();
    },
    saveData: function () {
      var _saveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var payload, action, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              if (!this.$v.$invalid) {
                _context.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context.n = 3;
              break;
            case 1:
              payload = this.form;
              action = this.createAccessGroup;
              if (this.idPage) {
                action = this.updateAccessGroup;
              }
              _context.n = 2;
              return action(payload);
            case 2:
              data = _context.v;
              if (data) {
                this.$buefy.toast.open({
                  message: 'Dados salvos com sucesso!',
                  type: 'is-success',
                  duration: 6000
                });
                this.$router.push({
                  path: "/access-control/access-group"
                });
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function saveData(_x) {
        return _saveData.apply(this, arguments);
      }
      return saveData;
    }(),
    getDetailDetailAccessGroup: function () {
      var _getDetailDetailAccessGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var accessGroup;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchAccessGroup(this.$route.params.id);
            case 1:
              accessGroup = _context2.v;
              this.form = _objectSpread(_objectSpread(_objectSpread({}, this.form), accessGroup), {}, {
                canViewSensitiveData: !!(accessGroup !== null && accessGroup !== void 0 && accessGroup.canViewSensitiveData)
              });
              this.getLinkPagesTable();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetailDetailAccessGroup() {
        return _getDetailDetailAccessGroup.apply(this, arguments);
      }
      return getDetailDetailAccessGroup;
    }(),
    goBack: function goBack() {
      this.$router.back();
    },
    getLinkPagesTable: function () {
      var _getLinkPagesTable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fetchPagesLinkGroup(this.form._id);
            case 1:
              this.listLinksPagesToGroup = _context3.v;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getLinkPagesTable() {
        return _getLinkPagesTable.apply(this, arguments);
      }
      return getLinkPagesTable;
    }(),
    confirmDelete: function confirmDelete(item) {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalWarning,
        hasModalCard: true,
        trapFocus: true,
        props: {
          text: 'Deseja realmente remover o vínculo da página',
          action: this.deleteItem,
          name: item.name,
          idItem: item.codPage,
          textConfirm: 'Remover'
        }
      });
    },
    openLinkPageToGroup: function openLinkPageToGroup() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalLinkPageAccessGroup,
        hasModalCard: true,
        customClass: 'modal-link-page-access-group',
        trapFocus: true,
        canCancel: ['escape', 'outside'],
        props: {
          actionUpdate: this.linkPageInAccesGroup
        }
      });
    },
    linkPageInAccesGroup: function () {
      var _linkPageInAccesGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
        var payload, linkPage;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              payload = {
                codGroup: this.form.codGroup,
                codPage: data
              };
              _context4.n = 1;
              return this.addPageToAccessGroup(payload);
            case 1:
              linkPage = _context4.v;
              if (linkPage) {
                this.getLinkPagesTable();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function linkPageInAccesGroup(_x2) {
        return _linkPageInAccesGroup.apply(this, arguments);
      }
      return linkPageInAccesGroup;
    }(),
    deleteItem: function () {
      var _deleteItem = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
        var payload, result;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              console.log(this.form.codGroup);
              payload = {
                codPage: id,
                codGroup: this.form.codGroup
              };
              _context5.n = 1;
              return this.removePageToAccessGroup(payload);
            case 1:
              result = _context5.v;
              if (result) {
                this.getLinkPagesTable();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function deleteItem(_x3) {
        return _deleteItem.apply(this, arguments);
      }
      return deleteItem;
    }()
  })
};